export const pages = [
  { name: 'Главная', href: '/' },
  { name: 'О нас', href: '/about' },
];

export default {
  pages,
};
